import WCAGComponent from '../_components/Navbar/WCAGComponent';
import { withRouter } from 'react-router-dom';

const AccessibilityDeclaration = () => {
    return (
        <>
            <WCAGComponent />
        </>
    );
};

export default AccessibilityDeclaration;
